document.querySelectorAll('[data-naire-guide]').forEach((root) => {
  const reveals = root.querySelectorAll('[data-naire-guide-reveal]');
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    reveals.forEach((element) => element.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.style.transitionDelay = `${Number(entry.target.dataset.naireGuideReveal || 0) * 75}ms`;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -50px 0px', threshold: 0 });
  reveals.forEach((element) => observer.observe(element));
});
